const validate = (values) => {
  // const errors = {}
  // if (!values.get('customerId')) {
  //   errors.customerId = 'Required';
  // }
  // if (!values.get('primaryContactId')) {
  //   errors.primaryContactId = 'Required';
  // }
  // if (!values.get('originId')) {
  //   errors.originId = 'Required';
  // }
  // if (!values.get('destinationId')) {
  //   errors.destinationId = 'Required';
  // }
  // if (!values.get('profile')) {
  //   errors.profile = 'Required';
  // }
  // return errors;
}

export default validate;



// WEBPACK FOOTER //
// ./src/components/Jobs/CreateJobDialog/validate.js